import { Grid2 } from "@mui/material";
import EventInfoCard from "../ui/EventInfoCard";

export default function DBEventsSection({events}) {

    return(
        <Grid2 container spacing={2} sx={{ mb: 2 }}>
            {events.map((event, index) => (
                <Grid2 key={index} size={{ xs: 6, md:3, lg:3 }}>
                    <EventInfoCard {...{event}} />
                </Grid2>
            ))}
        </Grid2>
    )
}